import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaAward, FaUsers, FaLeaf } from 'react-icons/fa';

const AboutSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const stats = [
    { icon: FaAward, value: '30+', label: 'Anos de Experiência' },
    { icon: FaUsers, value: '14k+', label: 'Clientes Satisfeitos' },
    { icon: FaLeaf, value: '100%', label: 'Compromisso Sustentável' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <section id="sobre" className="section-padding bg-white overflow-hidden">
      <div className="container-custom">
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center"
        >
          {/* Image Side */}
          <motion.div variants={itemVariants} className="relative">
            <img
              src="/images/resource/chooseus-1.png"
              alt="Sobre Arte Verde Jardins"
              className="w-full h-auto"
            />

            {/* Stats Cards */}
            <motion.div
              className="absolute -bottom-8 -right-8 bg-white rounded-xl shadow-xl p-6 hidden lg:block"
              variants={itemVariants}
            >
              <div className="flex items-center gap-4">
                <div className="bg-primary-100 p-3 rounded-lg">
                  <FaAward className="text-primary-500 text-3xl" />
                </div>
                <div>
                  <p className="text-3xl font-bold text-dark">30+</p>
                  <p className="text-sm text-gray-600">Anos de Tradição</p>
                </div>
              </div>
            </motion.div>
          </motion.div>

          {/* Content Side */}
          <motion.div variants={itemVariants} className="space-y-6">
            <div className="space-y-3">
              <span className="text-natureza font-semibold text-sm uppercase tracking-wider">
                Sobre Nós
              </span>
              <h2 className="text-floresta font-display">
                Tradição e <br />
                <span className="text-natureza italic">excelência em paisagismo</span>
              </h2>
            </div>

            <p className="text-jardim text-lg leading-relaxed">
              A Arte Verde surge dando continuidade a um legado familiar de três décadas no ramo de
              jardinagem e paisagismo, unindo tradição e inovação em cada projeto.
            </p>

            <p className="text-jardim leading-relaxed">
              Executamos projetos de pequeno, médio e grande porte por todo o Brasil, sempre
              investindo na qualidade como nosso grande diferencial. Sediados em São Paulo,
              conquistamos a confiança de milhares de clientes tendo como base nossos pilares de{' '}
              <strong className="text-natureza">Qualidade, Compromisso e Paixão!</strong>
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-3 gap-4 pt-6">
              {stats.map((stat) => (
                <motion.div
                  key={stat.label}
                  variants={itemVariants}
                  className="text-center space-y-2"
                >
                  <div className="flex justify-center">
                    <div className="bg-primary-50 p-3 rounded-lg">
                      <stat.icon className="text-primary-500 text-2xl" />
                    </div>
                  </div>
                  <p className="text-2xl font-bold text-dark">{stat.value}</p>
                  <p className="text-xs text-gray-600">{stat.label}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
